import { initializeApp } from "@firebase/app";
import { getMessaging } from "@firebase/messaging";
import { fcmCredentials } from "./mixins/Credentials";

var firebaseConfig = {
    apiKey: fcmCredentials.apiKey,
    authDomain: fcmCredentials.authDomain,
    databaseURL: fcmCredentials.databaseURL,
    projectId: fcmCredentials.projectId,
    storageBucket: fcmCredentials.storageBucket,
    messagingSenderId: fcmCredentials.messagingSenderId,
    appId: fcmCredentials.appId,
    measurementId: fcmCredentials.measurementId
};

const app = initializeApp(firebaseConfig);

const messaging = getMessaging(app);

export { messaging };